import React from "react";
import { View, TouchableOpacity, Image, Dimensions , Linking } from 'react-native';
import { server_var, themeColor } from '../../config/servervar';

export const Login = () => {
  const { width, height } = Dimensions.get('window');
  return (
    <View style={{ flex: 1, backgroundColor: 'white', justifyContent: 'center', alignItems: 'center', }}>
      <TouchableOpacity onPress={async () => Linking.openURL('https://allpharmasee.cpall.co.th')} >
        <Image source={{ uri: `${server_var.server_api}/images/New_ALL_PharmaSee.jpg` }} style={{ width, height }} resizeMode='contain' />
      </TouchableOpacity>
    </View>
  )
};